import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container"]

  connect() {
  }

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML("afterbegin", content)
  }

  remove(event) {
    event.preventDefault()
    const wrapper = event.target.closest("[data-new-record]")
    if (wrapper) wrapper.remove()
  }

  remove_persisted(event) {
    event.preventDefault()
    const wrapper = event.target.closest("[data-persisted-record]")
    if (wrapper) {
      // Find the existing _destroy hidden field and set its value to '1'
      const destroyField = wrapper.querySelector("input[name*='[_destroy]']")
      if (destroyField) {
        destroyField.value = '1'
        wrapper.classList.add('opacity-50', 'line-through', 'text-gray-400')
      }
    }
  }
}